import { NavItemType } from 'types';
import other from './other';

// ✅ Return NavItemTypeObject { items: NavItemType[] }
const getMenuItems = (role_id?: number): { items: NavItemType[] } => {
    return {
        items: [other(role_id ?? 0)]
    };
};

export default getMenuItems;
